import styled from "styled-components";
import { theme } from "../../../styles/theme";

export const Container = styled.div`
    width: 100%;
    height: auto;

    display: flex;
    flex-direction: column;
`;

export const Wrapper = styled.div` 
    width: 100%;
    height: auto;
    padding: 32px;

    display: flex;
    align-items: center;
    flex-direction: column;
`;

export const ContainerFilter = styled.div`
    width: 100%;
    height: auto;
    padding: 16px;

    gap: 16px;
    display: flex;
    align-items: center;

    border-radius: 16px;
    background-color: ${theme.colors.gray.Cinza_12};
`;

export const ButtonFilter = styled.button`
    all: unset;

    width: 44px;
    height: 44px;   

    display: flex;
    align-items: center;
    justify-content: center;

    cursor: pointer;

    >img {
        width: 100%;
        height: auto;
        max-width: 26px;
    }

    :hover {
        opacity: 0.7;
    }
`;

export const ContainerInputFilter = styled.div`
    width: 100%;
    height: auto;
    max-width: 15rem;
    padding: 11px 16px;

    gap: 0.5rem;
    display: flex;
    align-items: center;

    border-radius: 1.625rem;
    border: 1px solid #8A92A2;

    >img{
        width: auto;
        height: auto;

        display: flex;
        margin-top: 0.1875rem;
    }

    >input {
        all: unset;

        width: 100%;
        height: 1.375rem;

        display: flex;
        align-items: flex-start;

        ::placeholder {
            color: #8A92A2;
            font-weight: 400;
            font-size: 0.875rem;
            font-family: "Lato";
            line-height: 1.3125rem;
        }
    }

    @media (max-width: 395px) {
        >input {
            ::placeholder{
                font-size: 0.7rem;
            }
        }
    }
`

export const Content = styled.div`
    width: 100%;
    height: auto;
    padding-top: 8px;

    gap: 32px;
    display: flex;
    flex-direction: column;
`

export const ContainerTable = styled.div`
    width: 100%;
    height: auto;

    gap: ${props => props.hasGap ? '16px' : '0px'};
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    overflow-x: auto;

    border-radius: 8px;
    border: 2px solid ${theme.colors.gray.Cinza_12};

    /* width */
    ::-webkit-scrollbar {
        width: 0px;
        height: 1px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: transparent; 
    }
    
    /* Handle */
    ::-webkit-scrollbar-thumb {
        /* background: #888;  */
        background: transparent;
        border-radius: 8px;
        
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        /* background: #555;  */
    }
`

export const ContainerTableRow = styled.div`
    /* width: 100%; */
    /* width: 1471px; */
    width: max-content;

    height: auto;
    padding: 12px;

    gap: 8px;
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    flex-direction: row;

    cursor: ${props => props.cursor === true ? 'pointer' : 'not-allowed'};
    border-radius: 
    ${props => props.firstChild ? '8px 8px 0px 0px' : 
    props.lastChild ? '0px 0px 8px 8px' : '0px'};
    border-bottom: ${props => props.lastChild ? 'none' : `2px solid ${theme.colors.gray.Cinza_12}`};
    background-color: ${props => props.status === 'error' ? theme.colors.disabled.Fundo_Desabilitado : "transparent"};

    >div:nth-of-type(3){
        max-width: 240px;
        min-width: 240px;
    }

    >p{
        padding-right: 8px;

        white-space: nowrap;
    }

    >p:nth-of-type(2){
        padding-right: 4px;
    }
`

export const ContainerTableColumn = styled.div`
    width: auto;
    height: auto;

    display: flex;
    flex-direction: column;
`;

export const ContainerInfoTopBlack = styled.div`
    width: 100%;
    /* width: 1471px; */
    height: auto;
    padding: 8px 12px;

    gap: 8px;
    display: flex;

    border-radius: 8px 8px 0px 0px;
    background-color: ${theme.colors.gray.Cinza_2};
    
    >div{
        /* padding: 8px 12px; */
        /* background-color: ${theme.colors.gray.Cinza_2}; */
    }
`;

export const ContainerInfoTopLabel = styled.div`
    width: ${props => props.width ? `${props.width} !important` : 'auto'};
    min-width: ${props => props.minWidth ? `${props.minWidth} !important` : 'auto'};
    height: auto;
    max-width: ${props => props.maxWidth ? props.maxWidth : '100%'};
    padding: ${props => props.padding ? props.padding : '0'};

    display: flex;

    >p{
        white-space: nowrap;
    }
`;

export const ContainerCard = styled.div`
    width: 100%;
    height: auto;

    gap: 9px;
    display: flex;
    flex-direction: column;
`

export const TableRowCell = styled.div`
    min-width: ${props => props.minWidth ? props.minWidth : 'auto'};
    height: auto;

    display: flex;
    align-items: flex-start;
    justify-content: ${props => props.JustifyContent ? props.JustifyContent : 'none'};

    overflow-x: auto;

    >p{
        white-space: nowrap;
    }

    /* width */
  ::-webkit-scrollbar {
    width: 0px;
    height: 1px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: transparent; 
  }
  
  /* Handle */
  ::-webkit-scrollbar-thumb {
    /* background: #888;  */
    background: transparent;
    border-radius: 8px;
    
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    /* background: #555;  */
  }
`

export const ContainerRowCellSmall= styled.div` 
    height: auto;
    min-width: 65px;
    max-width: 240px;
    padding-right: 13px;
 
    gap: 8px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
`;

export const TableRowCellSmall = styled.div`
    width: auto;
    height: auto;
    min-width: ${props => props.minWidth ? props.minWidth : 'auto'};
    padding-right: ${props => props.paddingRight ? props.paddingRight : '13px'};

    display: flex;
    align-items: center;
`

export const TableRow = styled.div`
    width: 100%;
    height: auto;

    display: flex;
    justify-content: space-between;
`

export const TableRowContain = styled.div`
    width: auto;
    height: auto;

    gap: 8px;
    display: flex;
    align-items: center;
`

//Container das Células
export const ContainerRT = styled.div`
    min-width: 120px;
    height: auto;

    display: flex;
    align-items: flex-start;
`

export const ContainerProdutor = styled.div`
    min-width: 224px;
    height: auto;

    gap: 8px;
    display: flex;
    flex-direction: column;

    >p{
        white-space: nowrap;
    }
`

export const ContainerLocalAplicação = styled.div`
    min-width: 160px;
    height: auto;

    display: flex;
    align-items: flex-start;
`

export const ContainerCultura = styled.div`
    min-width: 120px;
    height: auto;

    display: flex;
    align-items: flex-start;
`


export const LoadingContainer = styled.div`
    width: 100%;
    min-height: 18rem;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const Loading = styled.div`

  @-webkit-keyframes rotating /* Safari and Chrome */ {
    from {
        -webkit-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    to {
        -webkit-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
  }
    
  @keyframes rotating {
    from {
        -ms-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -webkit-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    to {
        -ms-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -webkit-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
  }


  width: 80px;
  height: 80px;
  position: relative;

  background-color: transparent;
  border-top: 1px solid #2fbb69;
  border-bottom: 1px solid #2fbb69;
  border-left: 1px solid transparent;
  border-right: 1px solid transparent;
  border-radius: 50%;
  -webkit-animation: rotating 0.7s linear infinite;
  -moz-animation: rotating 0.7s linear infinite;
  -ms-animation: rotating 0.7s linear infinite;
  -o-animation: rotating 0.7s linear infinite;
  animation: rotating 0.7s linear infinite;

`;
